import { CsvHeaderModel } from '../../../models/CsvHeader';

export const MASTER_MAIN_GROUP_CSV_HEADER: CsvHeaderModel[] = [
  {
    label: 'id',
    key: 'no_main',
  },
  {
    label: 'mainGroupNameEn',
    key: 'main_group_name_en',
  },
  {
    label: 'mainGroupNameLa',
    key: 'main_group_name_la',
  },
  {
    label: 'description',
    key: 'description',
  },

  {
    label: 'code',
    key: 'code',
  },
];
